<template>
    <div class="navigation-tabs" :class="{isAtEnd}">
        <div ref="navigationContainerRef" class="navigation-tabs_container">
            <div class="navigation-tabs_container_list">
                <NavigationTab
                    :to="{name: 'project-projectId-index-activity', params: {projectId}}"
                    :label="t('projectclient.projectview.main.tab.activities')"
                    :notifications-count="activityNotificationCount"
                    data-id="activity"
                />
                <NavigationTab
                    :to="{name: 'project-projectId-index-invoices', params: {projectId}}"
                    :label="t('projectclient.projectview.main.tab.invoices')"
                    :notifications-count="0"
                    data-id="invoices"
                />
                <NavigationTab
                    :to="{name: 'project-projectId-index-details', params: {projectId}}"
                    :label="t('projectclient.projectview.main.tab.details')"
                    :notifications-count="0"
                    data-id="details"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {computed, useTemplateRef} from 'vue';
    import {useRoute} from '@typed-router';
    import {useTranslation} from '#imports';
    import {useScrollContainer} from '@malt/utils';
    import NavigationTab from './NavigationTab.vue';
    import {useActivityStore} from '@/features/project-view';

    const {t} = useTranslation();
    const {
        params: {projectId},
    } = useRoute('project-projectId-index');

    const activityStore = useActivityStore();

    const navigationContainerRef = useTemplateRef('navigationContainerRef');

    const {isAtEnd} = useScrollContainer({target: navigationContainerRef});

    const activityNotificationCount = computed(() => {
        return activityStore.pendingActions?.length ?? 0;
    });
</script>

<style lang="scss" scoped>
    .navigation-tabs {
        display: flex;
        width: 100%;

        &_container {
            display: flex;
            overflow-x: auto;
            width: 100%;

            &_list {
                display: flex;
                flex-flow: row nowrap;
                position: relative;
                width: 100%;

                &::after {
                    position: absolute;
                    content: '';
                    top: calc(100% - 2px);
                    height: 2px;
                    width: 100%;
                    left: 0;
                    z-index: 0;
                    background-color: var(--joy-color-neutral-30);
                }
            }
        }

        &::after {
            content: '';
            position: absolute;
            height: 100%;
            width: 60px;
            right: 0;
            background: linear-gradient(to right, rgb(255 255 255 / 0%), var(--joy-color-neutral-0));
            pointer-events: none;
        }

        &.isAtEnd {
            &::after {
                display: none;
            }
        }
    }
</style>
